module.exports = __webpack_public_path__ + "static/media/mukuaihua_06.4515e17f.png";